import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React from 'react';
import { connect } from 'react-redux';
import { goToSubCategory } from '../../actions/navigation';
import { getActiveCategoryID } from '../../reducers/categories';

import { getUriLangCode } from '../../reducers/i18n';
import { getPage } from '../../reducers/page';
import { getActiveSewpatId } from '../../reducers/sewpats';


class Navigation extends React.Component {

    state = {
        value: null,
    };

    handleChange = ( event, value ) => {
        this.setState({ value });
    };

    handleClick = categoryId => {
        this.props.dispatch(goToSubCategory(this.props.sewpatId, categoryId));
    };

    render () {
        const { classes } = this.props;
        const value = this.state.value || this.props.isNewest ||
            this.props.categoryId;

        return (
            <React.Fragment>
                <Tabs
                    value={value}
                    onChange={this.handleChange}
                    textColor='inherit'
                    scrollable
                    scrollButtons='auto'
                    classes={classes}
                >
                    <Tab
                        value='1'
                        component='a' label='Neu'
                        onClick={() => this.props.dispatch(
                            {
                                type: 'NAVIGATED_TO_NEWEST_PATTERNGALLERY',
                                payload: { sewpatId: this.props.sewpatId },
                            })}
                    />
                    <Tab value='2' label='Trends'
                         onClick={() => this.handleClick(2)}/>
                    <Tab value='255' onClick={() => this.handleClick(255)}
                         label='Zeitlos'/>
                    <Tab
                        value='278'
                        onClick={() => this.handleClick(278)}
                        label='Saisonal'
                    />
                    <Tab
                        value='299'
                        onClick={() => this.handleClick(299)}
                        label='Kulturen'
                    />
                    <Tab value='305' onClick={() => this.handleClick(305)}
                         label='Floral'/>
                    <Tab value='313' onClick={() => this.handleClick(313)}
                         label='Formen'/>
                    <Tab value='350' onClick={() => this.handleClick(350)}
                         label='Kiddies'/>
                </Tabs>
            </React.Fragment>
        );
    }
}


const makeMapStateToProps = ( initialState, initialOwnProps ) => {
    const lang = getUriLangCode(initialState);
    const sewpatId = getActiveSewpatId(initialState);
    const isNewest = getPage(initialState) === 'PatterngalleryNewest'
        ? 1
        : null;

    const mapStateToProps = state => (
        {
            lang,
            sewpatId,
            isNewest,
            categoryId: getActiveCategoryID(state),
            ...initialOwnProps,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/header/Navigation.js